import { IStateAction, IStateManagedEntity } from "./state-action";

/**
 * A reducer that can be used in combination with with reacts useReducer hook to CRUD an element state
 * @param elements
 * @param action
 */
export function genericCrudReducer<T extends IStateManagedEntity>(
  elements: T[],
  action: IStateAction<T>,
): T[] {
  return action.execute(elements);
}

/**
 * A reducer that can be used in combination with with reacts useReducer hook to CRUD elements in a state
 * @param state
 * @param keyToElements Has to point to an array of elements of type T
 * @param action
 */
export function genericObjectCrudReducer<T extends IStateManagedEntity, S>(
  state: S,
  keyToElements: keyof S,
  action: IStateAction<T>,
): T[] {
  return action.execute(state[keyToElements] as T[]);
}
